var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-carefully-empty"
  }, [_c('p', {
    staticClass: "tips"
  }, [_vm._v("这个城市你还没添加商品哦")]), _c('div', {
    staticClass: "add-btn",
    on: {
      "click": _vm.showDialog
    }
  }, [_c('span', [_vm._v("去添加商品")])]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.dialog.show,
      expression: "dialog.show"
    }],
    staticClass: "dialog"
  }, [_c('div', {
    staticClass: "overlay",
    class: {
      show: _vm.dialog.showContent
    },
    on: {
      "click": _vm.closeDialog
    }
  }), _c('div', {
    staticClass: "dialog-body",
    class: {
      show: _vm.dialog.showContent
    }
  }, [_c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-head"
  }, [_vm._v("添加商品小贴士")]), _c('div', {
    staticClass: "add-img"
  }), _vm._m(0), _c('div', {
    staticClass: "go-shopping-btn",
    on: {
      "click": _vm.goShopping
    }
  }, [_vm._v("我知道了")])]), _c('div', {
    staticClass: "close-btn",
    on: {
      "click": _vm.closeDialog
    }
  })])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "dialog-tips"
  }, [_vm._v("\n          点击心仪商品的海报按钮，商品就\n          "), _c('br'), _vm._v("添加到店铺精选了\n        ")]);
}];
export { render, staticRenderFns };